import styled, { css } from 'styled-components';

import { SonntagIcon } from "../../SonntagIcon";
import { Clickable } from "../../InternalComponents/Clickable";
import { omitProps } from "../../helpers";

import { elevation, elevationTransition } from "../../Styles/Utils";

export const IconWrapper = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__IconWrapper", componentId: "sc-nfhxeh-0" })(["margin:0 6px 0 0;display:flex;justify-content:center;align-items:center;width:24px;height:24px;", " & > svg{width:24px;height:24px;padding:0;fill:", ";}& *{fill:", ";}", ";"],






elevationTransition,





({ theme, color }) => color || theme.colors.Foreground,



({ theme, color }) => color || theme.colors.Foreground,


({ onlyIcon }) =>
onlyIcon &&
css(["margin:0 -6px;"]));




const ButtonView = omitProps(
'fullWidth',
'outlined',
'size',
'theme',
'accentColor',
'withIcon',
'onlyIcon',
'solid')(
Clickable);

export const StyledButton = /*#__PURE__*/styled(ButtonView).withConfig({ displayName: "styled__StyledButton", componentId: "sc-nfhxeh-1" })(["", ";position:relative;display:flex;justify-content:center;align-items:center;box-sizing:border-box;height:", ";background-color:", ";background-clip:", ";border-radius:", ";border-style:solid;border-width:2px;border-color:", ";min-width:0;color:", ";overflow:hidden;outline:none;padding:", ";", " &:visited{text-decoration:none;}&:disabled{transition:none;transform:none;opacity:0.4;cursor:default;}&:hover:not(:disabled){cursor:pointer;background-color:", ";border-color:", ";background-clip:padding-box;", "}&:active:not(:disabled){text-decoration:none;", ";transition-duration:0s;background-color:", ";border-color:", ";background-clip:padding-box;}", ";", ";", ";"],
(props) => css(props.theme.typography.SmallHeadline),





({ size }) => size && size === 'small' && '32px' || '48px',
({ theme }) => theme.colors['Level 1'],
({ solid }) => solid ? 'border-box' : 'padding-box',
({ size }) => size && size === 'small' && '16px' || '24px',


({ theme }) => theme.colors['Level 1'],

({ theme }) => theme.colors.Foreground,


({ withIcon, size, onlyIcon }) =>
withIcon && size === 'small' && onlyIcon && '0 8px' ||
withIcon && size === 'small' && !onlyIcon && '0 8px 0 4px' ||
withIcon && !size && '0 16px' ||
!withIcon && size === 'small' && '0 16px' ||
'0 24px',
elevationTransition,














({ theme }) => theme.colors.HoverBackground,
({ theme }) => theme.colors.HoverBackground,

elevation(2, false),




elevation(1, false),

({ theme }) => theme.colors.ElementBackground,
({ theme }) => theme.colors.ElementBackground,



({ accentColor, theme, solid, outlined }) =>
accentColor &&
css(["color:", ";background-color:", ";border-color:", ";& > svg,& *{fill:", ";}&:hover:not(:disabled){color:", ";background-color:", ";border-color:", ";& > svg,& *{fill:", ";}}&:active:not(:disabled){color:", ";background-color:", ";border-color:", ";& > svg,& *{fill:", ";}}"],
accentColor && solid && !outlined ? '#fff' : accentColor,
accentColor && solid && !outlined && accentColor ||
accentColor && outlined && !solid && 'transparent' ||
theme.colors['Level 1'],
(solid || outlined) && accentColor || theme.colors['Level 1'],



accentColor && solid && !outlined ? '#fff' : accentColor,



theme.colors.Foreground,
theme.colors.HoverBackground,
theme.colors.HoverBackground,



theme.colors.Foreground,




theme.colors.Foreground,
theme.colors.ElementBackground,
theme.colors.ElementBackground,


theme.colors.Foreground),




({ outlined }) =>
outlined &&
css(["background-color:transparent;"]),



({ fullWidth }) =>
fullWidth &&
css(["width:100%;"]));




export const StyledSonntagIcon = /*#__PURE__*/styled(SonntagIcon).withConfig({ displayName: "styled__StyledSonntagIcon", componentId: "sc-nfhxeh-2" })(["margin:0 6px 0 0;", ";"],


({ onlyIcon }) =>
onlyIcon &&
css(["margin:0 -6px;"]));




export const RippleContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__RippleContainer", componentId: "sc-nfhxeh-3" })(["width:100%;height:100%;position:absolute !important;top:0;left:0;"]);







export const TruncationWrapper = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__TruncationWrapper", componentId: "sc-nfhxeh-4" })(["vertical-align:center;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;"]);